// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (max-width: 470px) {
.vue-feedback-reaction .reaction {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease;
    margin: 0 auto;
    padding: 0 5px;
    cursor: pointer;
    font-size: 10px;
}
.vue-reaction img {
    height: 28px;
}
}
.vue-form-generator
  .form-group:not(.field-vueMultiSelect)
  .vue-feedback-reaction
  .reaction
  span {
  text-align: center;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
